import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getReservesAPI(params, config = {}) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "reserve_no": "219310",
          "start_time": "1629856800",
          "end_time": "1629858600",
          "attend_status": "0",
          "note": "",
          "tel": "(02)89115812",
          "line_bot_is_verified": "0",
          "address": "123",
          "county": "桃園市",
          "sex": "9",
          "name": "Eric",
          "phone": "0917088950",
          "birthday": "",
          "file_name_photo": "https://profile.line-scdn.net/0m0056e4197251ba7115fee6274fb6e2bb2eb9bb0b2350",
          "clinic_name": "Dent&Co牙醫診所1",
          "clinic_code": "0000000002",
          "doctor_name": "小幫手2號",
          "doctor_code": "5WJynO2zWz7w",
          "agree": "",
        }
      ]
    })
  }
  const url = apiUrl('reserves')
  return axios.get(url, {params, ...config})
}

export function getReserveDetailAPI(id, params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "reserve_no": "2092162",
        "start_time": "1630036800",
        "end_time": "1630037700",
        "attend_status": "0",
        "note": "test",
        "tel": "(02)89115812",
        "line_bot_is_verified": "1",
        "address": "",
        "county": "",
        "sex": "9",
        "name": "蔡友仁",
        "phone": "0922099195",
        "birthday": "570816000",
        "file_name_photo": "",
        "clinic_name": "Dent&Co牙醫診所1",
        "clinic_code": "0000000002",
        "doctor_name": "王醫師",
        "doctor_code": "eYt0LMKngllg",
        "agree": "1",
        "patient_code": "1f72ilba",
        "remind_cash": "1000",
        "remind_others": "帶一百塊",
        "appointment_count": "23",
        "change_count": "1",
        "stood_up_count": "0"
      }

    })
  }
  const url = apiUrl('reserves', id)
  return axios.get(url, {params})
}

// Reserves Specify (3M/6M 定检提醒、额外提醒、备注)

// Reserves Specify (3M/6M 定检提醒、额外提醒、备注)
export function getReservesSpecifyAPI(params, config = {}) {
  const url = apiUrl('reserves-specify')
  return axios.get(url, {params, ...config})
}

export function getReserveSpecifyDetailAPI(id, params) {
  const url = apiUrl('reserves-specify', id)
  return axios.get(url, {params})
}

export function createReserveSpecifyAPI(data) {
  const url = apiUrl('reserves-specify')
  return axios.post(url, data)
}

export function updateReserveSpecifyAPI(id, data) {
  const url = apiUrl('reserves-specify', id)
  return axios.put(url, data)
}

export function deleteReserveSpecifyAPI(id, data) {
  const url = apiUrl('reserves-specify', 'change_status', id)
  return axios.put(url, data)
}

export function remindReserveSpecifyAPI(data) {
  const url = apiUrl('reserves-specify', 'remind')
  return axios.post(url, data)
}

export function printReserveExcel(params) {
  if (useMock) {
    return Promise.resolve({
      data: new Blob(['\uFEFF預約日期,約診時間\n'], {type: 'text/csv;charset=utf-8;'}),
      headers: {
        'content-disposition': 'attachment; filename=reserve.csv'
      },
    })
  }
  const url = apiUrl('reserves', 'download')
  const requestParams = {...params, format: 'xls'}
  return axios.get(url, {params: requestParams, responseType: 'blob'})
}

export function createReserveAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves')
  return axios.post(url, data)
}

export function createBatchReserveAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'batch')
  return axios.post(url, data)
}

export function updateReserveAPI(id, data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功",
        "remind_text": "蔡友仁您好，您與 王醫師醫師 的約診時間已更改為 2021-08-25(三)08:55 於 Dent&Co牙醫診所1，如有任何問題請電洽 (02)89115812 確認。"
      }
    })
  }
  const url = apiUrl('reserves', id)
  return axios.put(url, data)
}

export function RemindChangeAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'remind_change')
  return axios.post(url, data)
}

export function updateReserveStatusAPI(id, data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'change_status', id)
  return axios.put(url, data)
}

export function getPatientReserveRecordAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "start_time": "2021-08-27 12:00",
          "attend_status": "0",
          "clinic_name": "Dent&Co牙醫診所1",
          "doctor_name": "王醫師",
          "title": "醫師"
        },
        {
          "start_time": "2021-08-25 12:00",
          "attend_status": "-1",
          "clinic_name": "Dent&Co牙醫診所1",
          "doctor_name": "王醫師",
          "title": "醫師"
        }
      ]
    })
  }
  const url = apiUrl('patients', 'reserves')
  return axios.get(url, {params})
}

export function sendSingleMessageAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'send_message')
  return axios.post(url, data)
}

export function sendSingleSMSMessageAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('sms', 'send_message')
  return axios.post(url, data)
}

export function sendReserveRemindAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'remind')
  return axios.post(url, data)
}

export function sendReserveSurveyAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'remind_survey')
  return axios.post(url, data)
}

export function sendReserveHealthEducationAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'send_health')
  return axios.post(url, data)
}

export function sendCustomizeCareAPI(data) {
  const url = apiUrl('reserves', 'send_customize_care')
  return axios.post(url, data)
}

export function checkDuplicateCustomizeCareAPI(params) {
  const url = apiUrl('check-customize-care-send-queue')
  return axios.get(url, {params})
}

export function createTelemedicineAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'google_meet')
  return axios.post(url, data)
}

export function updateTelemedicineAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'google_meet')
  return axios.put(url, data)
}

export function remindTelemedicineAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'remind_google_meet')
  return axios.post(url, data)
}

export function sendReserveCareAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'remind_care')
  return axios.post(url, data)
}

export function sendReserveBeforeCareAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'remind_before_care')
  return axios.post(url, data)
}

export function sendSmsReserveCareAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('sms', 'remind_care')
  return axios.post(url, data)
}

export function sendSmsReserveBeforeCareAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('sms', 'remind_before_care')
  return axios.post(url, data)
}

export function sendSmsReserveSurveyAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('sms', 'remind_survey')
  return axios.post(url, data)
}

export function getReserveTagAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "tag_id": "3",
          "content": "收取100費用"
        },
        {
          "tag_id": "4",
          "content": "講台語"
        },
        {
          "tag_id": "5",
          "content": "龜毛"
        }
      ]
    })
  }
  const url = apiUrl('tag', 'reserve_tag')
  return axios.get(url, {params})
}

export function updateReserveTagAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('tag', 'reserve_tag')
  return axios.post(url, data)
}
